import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7568748c")

_pushScopeId("data-v-7568748c")
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "describe" }
const _hoisted_3 = { class: "describe" }
_popScopeId()

import { defineComponent, reactive, toRefs, ref, onMounted } from "vue";
import { api } from "@/apis/user";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";

interface Option {
  key: number;
  label: string;
  disabled: boolean;
}
interface listOption {
  gid: any;
  name: any;
}
interface stateTypes {
  data: { key: String; label: String }[];
}
interface stateForm {
  gid: any;
  gids: any;
  attrib: any;
  upper: any;
}

export default _defineComponent({
  expose: [],
  setup(__props) {

const groupForm = ref();
const { t } = useI18n();
const listQuery = {
  pageSize: 10,
  pageNo: 1
};
const dataMap = reactive({
  value: "",
  list: [],
  total: 0,
  tableKey: 0,
  listLoading: false,
  chirldlist: []
});
const rules = reactive({
  gid: [
    {
      required: true,
      message: t("input.Please select a group"),
      trigger: "change"
    }
  ]
});
const dataList = reactive<stateTypes>({
  data: []
});
const optionList = reactive({
  options: ref<listOption>()
});
const form = reactive<stateForm>({
  gids: [],
  gid: null,
  attrib: ref(),
  upper: ref()
});
const toRowDelete = async (row: any) => {
  const { data }: any = await api.revise.parentchilddelete({
    parentGid: row.gid
  });
  if (data.status === 200) {
    ElMessage.success(t("table.delete success"));
    getList();
  }
};
const filterMethod = (query: any, item: any) => {
  let a = String(item.key);
  return a.indexOf(query) > -1 || item.label.indexOf(query) > -1;
};
const handleSizeChange = (val: any) => {
  dataMap.value = val;
  getList(1, val);
};
const handleCurrentChange = (page: any) => {
  getList(page, dataMap.value);
};
const getList = async (pageSize?: any, pageNo?: any) => {
  dataMap.listLoading = true;
  if (pageSize) {
    listQuery.pageSize = pageSize;
  }
  if (pageNo) {
    listQuery.pageNo = pageNo;
  }
  listQuery.pageSize = pageSize;
  listQuery.pageNo = pageNo;

  const { data }: any = await api.list.parenList(listQuery);
  dataMap.list = data.data.resultList;
  dataMap.total = data.data.totalCount;
  setTimeout(() => {
    dataMap.listLoading = false;
  }, 0.3 * 1000);
};
const expandChange = async (row: any, e: any) => {
  console.log(row, e);
  if (e.length > 0) {
    const { data }: any = await api.revise.groupnestedes({
      parentGid: row.gid,
      pageNo: 1,
      pageSize: 2000
    });
    dataMap.chirldlist = data.data.resultList;
  }
};
const chageSelect = async () => {
  dataList.data = [];
  const { data }: any = await api.revise.groupchildlist({
    parentGid: form.gid,
    pageNo: 1,
    pageSize: 5000
  });
  const rightdata: any = await api.revise.groupnestedes({
    parentGid: form.gid,
    pageNo: 1,
    pageSize: 5000
  });
  const rightList: any = rightdata.data.data.resultList;
  const resultMap: any = data.data.resultMap;
  form.attrib = resultMap.attrib;
  form.upper = resultMap.upper;
  const leftList: any = data.data.resultList;
  const concatList: any = leftList.concat(rightList);
  for (let i of concatList) {
    dataList.data.push({
      label: i?.name,
      key: i?.gid
    });
  }
  if (rightList.length > 0) {
    for (let i of rightList) {
      form.gids.push(i?.gid);
    }
  }
};
const deleteTable = async (row: any) => {
  console.log(row);
};
const getGroupList = async () => {
  const dataList: any = await api.list.groupnofater({
    page: { pageNo: 1, pageSize: 10000 }
  });
  optionList.options = dataList.data.data.resultList;
};
// 提交
const submit = () => {
  groupForm.value.validate(async (valid: any) => {
    if (valid) {
      if (form.attrib == true) {
        form.attrib = 1;
      } else {
        form.attrib = 0;
      }
      if (form.upper == true) {
        form.upper = 1;
      } else {
        form.upper = 0;
      }
      // 默认打开允许子组之间呼叫
      form.attrib = 1;

      const status: any = await api.table.groupparentchildset(form);
      if (status.data.status === 200) {
        ElMessage.success(t("table.success"));
        location.reload();
      } else {
        return;
      }
    }
  });

  console.log(form);
};
const handleChange = (
  value: number | string,
  direction: "left" | "right",
  movedKeys: string[] | number[]
) => {
  console.log(value, direction, movedKeys);
};
onMounted(() => {
  getGroupList();
  getList();
});

return /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_transfer = _resolveComponent("el-transfer")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: form,
      "label-width": "120px",
      width: "200",
      rules: rules,
      ref: groupForm
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.selectGroup'),
          prop: "gid"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_select, {
              modelValue: form.gid,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (form.gid = $event)),
              class: "m-2",
              filterable: "",
              clearable: "",
              placeholder: _unref(t)('input.Please select a group'),
              size: "large",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (chageSelect()))
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(optionList.options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.gid,
                    label: item.name,
                    value: item.gid
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, null, {
          default: _withId(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: form.upper,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (form.upper = $event)),
              label: _ctx.$t('input.Allow child groups to report to the parent group'),
              size: "large"
            }, null, 8, ["modelValue", "label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withId(() => [
            _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(
              "input.Groups that become child groups cannot be added as parent groups"
            )), 1),
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(
              "input.A member of a child group cannot be a member of the parent group at the same time, otherwise the user cannot form a parent-child relationship"
            )), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('form.childgroup')
        }, {
          default: _withId(() => [
            _createVNode(_component_el_transfer, {
              modelValue: form.gids,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (form.gids = $event)),
              "filter-placeholder": _ctx.$t('input.Please enter an ID or name'),
              "filter-method": filterMethod,
              style: {"text-align":"left","display":"inline-block"},
              filterable: "",
              titles: [_ctx.$t('table.Items'), _ctx.$t('table.Selected')],
              data: dataList.data,
              onChange: handleChange
            }, {
              default: _withId(({ option }) => [
                _createVNode("span", null, _toDisplayString(option.key) + "--" + _toDisplayString(option.label), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "filter-placeholder", "titles", "data"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, null, {
          default: _withId(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (submit())),
              type: "primary"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("table.confirm")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    _withDirectives(_createVNode(_component_el_table, {
      data: dataMap.list,
      onExpandChange: expandChange,
      key: dataMap.tableKey,
      border: "",
      "highlight-current-row": "",
      style: {"width":"100%"}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, { type: "expand" }, {
          default: _withId((props) => [
            _createVNode(_component_el_table, {
              data: dataMap.chirldlist
            }, {
              default: _withId(() => [
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('table.Child')
                }, {
                  default: _withId(({ row }) => [
                    _createTextVNode(_toDisplayString(row.name), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('table.Parent')
        }, {
          default: _withId(({ row }) => [
            _createTextVNode(_toDisplayString(row.name), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('table.type')
        }, {
          default: _withId(({ row }) => [
            _createTextVNode(_toDisplayString(row.upper == 1
              ? _ctx.$t("table.Debriefingtype")
              : _ctx.$t("table.Directivetype")), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('table.actions'),
          width: "320",
          "class-name": "buttonSize"
        }, {
          default: _withId((scope) => [
            _createVNode(_component_el_popconfirm, {
              "confirm-button-text": _ctx.$t('table.confirm'),
              "cancel-button-text": _ctx.$t('table.cancel'),
              "icon-color": "red",
              title: _ctx.$t('input.Are you sure to delete'),
              onConfirm: ($event: any) => (toRowDelete(scope.row))
            }, {
              reference: _withId(() => [
                _createVNode(_component_el_button, { size: "small" }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("table.delete")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["confirm-button-text", "cancel-button-text", "title", "onConfirm"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"]), [
      [_directive_loading, dataMap.listLoading]
    ]),
    _withDirectives(_createVNode(_component_el_pagination, {
      total: dataMap.total,
      currentPage: listQuery.pageNo,
      "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => (listQuery.pageNo = $event)),
      limit: listQuery.pageSize,
      "onUpdate:limit": _cache[7] || (_cache[7] = ($event: any) => (listQuery.pageSize = $event)),
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange,
      "page-sizes": [10, 20, 50, 100],
      layout: "total, sizes, prev, pager, next, jumper"
    }, null, 8, ["total", "currentPage", "limit"]), [
      [_vShow, dataMap.total > 0]
    ])
  ]))
})
}

})